<template>
  <div>
    <b-row>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>First Year of Studies (PhD):</strong>
          </p>
          <ol>
            <li>"Individual Plan (up to 5 MB)" (pdf).</li>
            <li>"Theoretical and Methodological Program (up to 5 MB)" (pdf).</li>
            <li>"Scientific Article (up to 5 MB)" (pdf). (At least one)</li>
            <li>"Thesis (up to 5 MB)" (pdf). (At least one)</li>
            <li>"Analytical Information on the Dissertation Topic (up to 5 MB)" (pdf).</li>
            <li>"Seminar Report (up to 5 MB)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Second Year of Studies (PhD):</strong>
          </p>
          <ol>
            <li>"Scientific Article (up to 5 MB)" (pdf). (At least one)</li>
            <li>"Thesis (up to 5 MB)" (pdf). (At least one)</li>
            <li>"Foreign Scientific Article (up to 5 MB)" (pdf). (At least one)</li>
            <li>"Seminar Report (up to 5 MB)" (pdf).</li>
            <li>"Report (up to 5 MB)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Third Year of Studies (PhD):</strong>
          </p>
          <ol>
            <li>"Scientific Article (up to 5 MB)" (pdf). (At least one)</li>
            <li>"Thesis (up to 5 MB)" (pdf). (At least one)</li>
            <li>"Foreign Scientific Article (up to 5 MB)" (pdf). (At least one)</li>
            <li>"Dissertation (up to 15 MB)" (pdf).</li>
            <li>"Dissertation Abstract (up to 7 MB)" (pdf).</li>
            <li>"Seminar Report (up to 5 MB)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="4"
        md="4"
      > <b-card
        id="guide"
        style="font-family: TimesNewRoman,serif; font-size: 18px"
      >
        <p style="font-size: 20px;">
          <strong>First Year of Studies (DSc):</strong>
        </p>
        <ol>
          <li>"Individual Plan (up to 5 MB)" (pdf).</li>
          <li>"Scientific Article (up to 5 MB)" (pdf). (At least three) The number of articles is unlimited.</li>
          <li>"Thesis (up to 5 MB)" (pdf). (At least one)</li>
          <li>"Seminar Report (up to 5 MB)" (pdf).</li>
        </ol>
      </b-card></b-col>
      <b-col
        cols="4"
        md="4"
      ><b-card
        id="guide"
        style="font-family: TimesNewRoman,serif; font-size: 18px"
      >
        <p style="font-size: 20px;">
          <strong>Second Year of Studies (DSc):</strong>
        </p>
        <ol>
          <li>"Scientific Article (up to 5 MB)" (pdf). (At least three) The number of articles is unlimited.</li>
          <li>"Foreign Scientific Article (up to 5 MB)" (pdf). (At least one) The number of articles is unlimited.</li>
          <li>"Thesis (up to 5 MB)" (pdf). (At least one) The number of theses is unlimited.</li>
          <li>"Seminar Report (up to 5 MB)" (pdf).</li>
          <li>"Report (up to 5 MB)" (pdf).</li>
        </ol>
      </b-card></b-col>
      <b-col
        cols="4"
        md="4"
      ><b-card
        id="guide"
        style="font-family: TimesNewRoman,serif; font-size: 18px"
      >
        <p style="font-size: 20px;">
          <strong>Third Year of Studies (DSc):</strong>
        </p>
        <ol>
          <li>"Article (up to 5 MB)" (pdf). (At least three) The number of articles is unlimited.</li>
          <li>"Monograph (up to 15 MB)" (pdf). (In social-humanitarian sciences)</li>
          <li>"Dissertation (up to 15 MB)" (pdf).</li>
          <li>"Dissertation Abstract (up to 7 MB)" (pdf).</li>
          <li>"Seminar Report (up to 5 MB)" (pdf).</li>
        </ol>
      </b-card></b-col>
    </b-row>
    <b-card
      id="guide"
      style="font-family: TimesNewRoman,serif; font-size: 18px"
    >
      <p style="font-size: 20px;">
        <strong>First Year of Studies (Junior Researcher):</strong>
      </p>
      <ol>
        <li>"Individual Plan (pdf, up to 5 MB)".</li>
        <li>"Scientific Article (pdf, up to 5 MB)". (At least one)</li>
        <li>"Thesis (pdf, up to 5 MB)". (At least one)</li>
      </ol>
    </b-card>

  </div>
</template>

<script>
import { BCard, BCol, BRow } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCard,
    BCol,
  },
}
</script>

<style scoped>

</style>
